<template>
  <div class="content">
    <header class="header" :class="{ active: isHeaderActive }">
      <div class="container">
        <div class="overlay" :class="{ active: isMenuActive }" @click="toggleMenu"></div>

        <a href="/">
        <!--  <h1 class="logo-img"><img src="../../assets/img/logo.png"> </h1>-->
           <div class="logo-menu" > <img src="/img/logo.png" alt=""> </div>
        </a>

        <nav class="navbar" :class="{ active: isMenuActive }">
          <div class="navbar-top">
            <a href="#home" class="logo">360</a>
            <button class="nav-close-btn" aria-label="Close Menu" @click="toggleMenu">
              <ion-icon name="close-outline"> </ion-icon>
            </button>
          </div>
   <ul class="navbar-list">
            <li class="navbar-item">
              <a href="#home" class="navbar-link" @click="closeMenu">Home</a>
            </li>
            <li class="navbar-item">
              <a href="#about" class="navbar-link" @click="closeMenu">About</a>
            </li>
               <li class="navbar-item">
              <a href="#pillars" class="navbar-link" @click="closeMenu">Pillars</a>
            </li>
            <li class="navbar-item">
              <a href="#services" class="navbar-link" @click="closeMenu">Services</a>
            </li>
            <li class="navbar-item">
              <a href="#methodology" class="navbar-link" @click="closeMenu">Methodology</a>
            </li>
              <li class="navbar-item">
              <a href="#features" class="navbar-link" @click="closeMenu">Customers</a>
            </li>
                <li class="navbar-item">
              <a href="#features" class="navbar-link" @click="closeMenu">Partners</a>
            </li>
     <!--
            <li class="navbar-item">
              <a href="#footer" class="navbar-link" @click="closeMenu">Contact Us</a>
            </li>
            -->
          </ul>
        </nav>
        <!--
        <a href="#" class="btn">
          <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
          <span>Get A Quote</span>
        </a>
        -->

        <button class="nav-open-btn" aria-label="Open Menu" @click="toggleMenu">
          <ion-icon name="menu-outline"> <i class="fa fa-bars" aria-hidden="true"></i></ion-icon>
        </button>
      </div>
    </header>

    <button class="go-top" :class="{ active: isGoTopActive }">
      <ion-icon name="arrow-up-outline" aria-hidden="true"></ion-icon>
    </button>
  </div>
</template>

<script>
import { useNavbar } from '@/composables/useNavbar';

export default {
  setup() {
    const { isMenuActive, isHeaderActive, isGoTopActive, toggleMenu, handleScroll } = useNavbar();

    return {
      isMenuActive,
      isHeaderActive,
      isGoTopActive,
      toggleMenu,
      handleScroll,
    };
  },
};
</script>

<style scoped>
.logo-img{
  width: 8%;
}
.logo-img img{
  width: 80%;
}
:root {
  /**
   * colors
   */

  --st-patricks-blue: hsl(236, 57%, 28%);
  --amaranth-purple: hsl(335, 88%, 38%);
  --royal-blue-dark: hsl(0, 100%, 20%);
  --chrome-yellow: hsl(39, 100%, 52%);
  --space-cadet-1: hsl(230, 41%, 25%);
  --space-cadet-2: hsl(230, 59%, 16%);
  --winter-sky_50: hsla(335, 87%, 53%, 0.5);
  --purple-navy: hsl(236, 26%, 43%);
  --ksu-purple: hsl(25, 47%, 84%);
  --winter-sky: hsl(335, 87%, 53%);
  --razzmatazz: hsl(335, 87%, 51%);
  --platinum: hsl(0, 0%, 90%);
  --black_70: hsla(0, 0%, 0%, 0.7);
  --rajah: hsl(29, 99%, 67%);
  --white: hsl(0, 0%, 100%);

  --gradient-1: linear-gradient(
    90deg,
    var(--royal-blue-dark) 0,
    var(--ksu-purple) 51%,
    var(--royal-blue-dark)
  );
  --gradient-2: linear-gradient(90deg, var(--razzmatazz), var(--rajah));

  /**
   * typography
   */

  --ff-source-sans-pro: "Source Sans Pro", sans-serif;
  --ff-poppins: "Poppins", sans-serif;

  --fs-1: 4.2rem;
  --fs-2: 3.8rem;
  --fs-3: 3.2rem;
  --fs-4: 2.5rem;
  --fs-5: 2.4rem;
  --fs-6: 2rem;
  --fs-7: 1.8rem;
  --fs-8: 1.5rem;

  --fw-500: 500;
  --fw-600: 600;
  --fw-700: 700;

  /**
   * border radius
   */

  --radius-4: 4px;
  --radius-12: 12px;

  /**
   * spacing
   */

  --section-padding: 60px;

  /**
   * transition
   */

  --transition-1: 0.15s ease;
  --transition-2: 0.35s ease;
  --cubic-in: cubic-bezier(0.51, 0.03, 0.64, 0.28);
  --cubic-out: cubic-bezier(0.33, 0.85, 0.56, 1.02);

  /**
   * shadow
   */

  --shadow: 0 5px 20px 1px hsla(220, 63%, 33%, 0.1);
}

/*-----------------------------------*\
  #RESET
\*-----------------------------------*/

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
 
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

a,
img,
span,
input,
button,
ion-icon {
  display: block;
}

button,
input {
  background: none;
  border: none;
  font: inherit;
}

button {
  cursor: pointer;
}

input {
  width: 100%;
}

ion-icon {
  pointer-events: none;
}

img {
  height: auto;
}

address {
  font-style: normal;
}

html {
  font-family: var(--ff-poppins);
  font-size: 10px;
  scroll-behavior: smooth;
}

body {
  background-color: var(--white);
  color: var(--purple-navy);
  font-size: 1.6rem;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: hsl(0, 0%, 95%);
}

::-webkit-scrollbar-thumb {
  background-color: hsl(0, 0%, 80%);
}

::-webkit-scrollbar-thumb:hover {
  background-color: hsl(0, 0%, 70%);
}

/*-----------------------------------*\
  #REUSED STYLE
\*-----------------------------------*/

.container {
  padding-inline: 15px;
}

.h2,
.h3 {
  font-family: var(--ff-source-sans-pro);
}

.btn {
  background-image: var(--gradient-2);
  background-size: 200%;
  color: var(--white);
  padding: 12px 35px;
  font-size: var(--fs-8);
  font-weight: var(--fw-500);
  border-radius: 0 25px;
  transition: var(--transition-2);
}

.btn:is(:hover, :focus) {
  background-position: right;
}

.w-100 {
  width: 100%;
}

.banner-animation {
  animation: waveAnim 1s linear infinite alternate;
}
.logo-menu{
  width: 9%;
}
.logo-menu img{
  width: 100%;
}

@keyframes waveAnim {
  0% {
    transform: translate(0, 0) rotate(0);
  }
  100% {
    transform: translate(2px, 2px) rotate(1deg);
  }
}

.section {
  padding-block: var(--section-padding);
}

.section-title {
  color: var(--st-patricks-blue);
  font-size: var(--fs-3);
  margin-block-end: 60px;
  max-width: max-content;
  margin-inline: auto;
}

.underline {
  position: relative;
}

.underline::before {
  content: "";
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  height: 6px;
  background-image: var(--gradient-2);
  border-radius: 10px;
}

:is(.service-card, .features-card) .title {
  color: var(--st-patricks-blue);
  font-size: var(--fs-4);
  font-weight: var(--fw-700);
}

:is(.service-card, .features-card, .blog-card) .text {
  font-size: var(--fs-8);
}

.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/*-----------------------------------*\
  #HEADER
\*-----------------------------------*/

.header .btn {
  display: none;
}

.header {
  --color: var(--white);

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-block: 14px;
  z-index: 4;
  transition: var(--transition-1);
}

.header.active {
  --color: var(--st-patricks-blue);

  position: fixed;
  background-color: var(--white);
  box-shadow: 0 2px 30px hsla(0, 0%, 0%, 0.1);
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.logo {
  color: var(--color);
  font-family: var(--ff-source-sans-pro);
  font-size: var(--fs-3);
}

.nav-open-btn {
  color: var(--color);
  font-size: 32px;
  padding: 4px;
}

.navbar {
  background-color: var(--white);
  position: fixed;
  top: 0;
  left: -280px;
  width: 100%;
  max-width: 280px;
  min-height: 100%;
  padding: 20px;
  visibility: hidden;
  z-index: 2;
  transition: 0.25s var(--cubic-in);
}

.navbar.active {
  transform: translateX(280px);
  visibility: visible;
  transition: 0.5s var(--cubic-out);
}

.navbar-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-block: 10px 30px;
}

.navbar-top .logo {
  color: var(--st-patricks-blue);
  font-size: 4.2rem;
  font-weight: var(--fw-700);
}

.nav-close-btn {
  color: var(--space-cadet-1);
  font-size: 2.8rem;
  padding: 4px;
}

.navbar-item:not(:last-child) {
  border-bottom: 1px solid var(--platinum);
}

.navbar-link {
  color: var(--space-cadet-1);
  font-size: var(--fs-8);
  font-weight: var(--fw-600);
  padding-block: 12px;
}



.overlay.active {
  opacity: 1;
  pointer-events: all;
}

/*-----------------------------------*\
  #GO TO TOP
\*-----------------------------------*/

.go-top {
  position: fixed;
  bottom: 0;
  right: 15px;
  background-color: var(--royal-blue-dark);
  color: var(--white);
  font-size: 2rem;
  padding: 14px;
  border-radius: var(--radius-4);
  box-shadow: -3px 3px 15px var(--royal-blue-dark);
  z-index: 2;
  visibility: hidden;
  opacity: 0;
  transition: var(--transition-1);
}

.go-top.active {
  visibility: visible;
  opacity: 1;
  transform: translateY(-15px);
}

/*-----------------------------------*\
  #MEDIA QUERIES
\*-----------------------------------*/

/**
  * responsive for larger than 992px screen
  */

@media (min-width: 992px) {
  .overlay,
  .nav-open-btn,
  .navbar-top {
    display: none;
  }

  .navbar {
    all: unset;
    margin-inline-start: auto;
    display: flex;
    gap: 25px;
  }

  .navbar-list {
    display: flex;
    gap: 25px;
  }

  .navbar-item:not(:last-child) {
    border-bottom: none;
  }

  .navbar-link {
    color: var(--color);
  }
}
.overlay {
  position: fixed;
  inset: 0;
  background-color: var(--black_70);
  z-index: 1;
  opacity: 0;
  pointer-events: none;
  transition: var(--transition-2);
}

.overlay.active {
  opacity: 1;
  pointer-events: all;
}

/*-----------------------------------*\
  #GO TO TOP
\*-----------------------------------*/

.go-top {
  position: fixed;
  bottom: 0;
  right: 15px;
  background-color: var(--title-color);
  color: var(--white);
  font-size: 2rem;
  padding: 14px;
  border-radius: var(--radius-4);
  box-shadow: -3px 3px 15px var(--title-color);
  z-index: 2;
  visibility: hidden;
  opacity: 0;
  transition: var(--transition-1);
}

.go-top.active {
  visibility: visible;
  opacity: 1;
  transform: translateY(-15px);
}

/*-----------------------------------*\
  #MEDIA QUERIES
\*-----------------------------------*/

/**
 * responsive for larger than 550px screen
 */

@media (min-width: 550px) {
  /**
   * REUSED STYLE
   */

  .container {
    max-width: 550px;
    margin-inline: auto;
  }

  .section-title {
    --fs-3: 3.6rem;
  }

  /**
   * HEADER
   */

  .header .btn {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-inline-start: auto;
  }

  /**
   * ABOUT
   */

  .stats-list {
    grid-template-columns: repeat(3, 1fr);
  }

  /**
   * BLOG
   */

  .blog-card {
    display: grid;
    grid-template-columns: 0.75fr 1fr;
    gap: 20px;
    padding: 30px;
  }

  .blog-card .banner {
    margin-block-end: 0;
  }

  .blog-card .banner a {
    height: 100%;
  }

  /**
   * FOOTER
   */

  .footer-brand,
  .footer-list:not(:last-child) {
    margin-block-end: 0;
  }

  .footer-top .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px 50px;
  }
}

/**
 * responsive for larger than 768px screen
 */

@media (min-width: 768px) {
  /**
   * REUSED STYLE
   */

  .container {
    max-width: 720px;
  }

  /**
   * HERO
   */

  .hero {
    min-height: 600px;
    display: grid;
    place-items: center;
 
  }

  .hero-content {
    margin-block-end: 0;
  }

  .hero .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 30px;
  }

  /**
   * SERVICE
   */

  .service-list {
    grid-template-columns: 1fr 1fr;
  }

  /**
   * FEATURES
   */

  .features-list > li:first-child {
    margin-block-end: 0;
  }

  .features-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
  }

  /**
   * FOOTER
   */

  .footer-top .container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/**
 * responsive for larger than 992px screen
 */

@media (min-width: 992px) {
  /**
   * CUSTOM PROPERTY
   */

  :root {
    /**
     * typography
     */

    --fs-1: 5.4rem;
  }

  /**
   * REUSED STYLE
   */

  .container {
    max-width: 950px;
  }

  /**
   * HEADER
   */

  .header {
    padding-block: 20px;
  }

  .overlay,
  .nav-open-btn,
  .navbar-top {
    display: none;
  }

  .navbar,
  .navbar.active {
    all: unset;
    margin-inline-start: auto;
  }

  .header .btn {
    margin-inline-start: 0;
  }

  .navbar-list {
    display: flex;
    gap: 25px;
  }

  .navbar-item:not(:last-child) {
    border-bottom: none;
  }

  .navbar-link {
    color: var(--color);
  }

  /**
   * HERO
   */

  .hero {
    min-height: 700px;
  }

  /**
   * ABOUT
   */

  .about .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  /**
   * SERVICE
   */

  .service-list {
    grid-template-columns: repeat(3, 1fr);
  }

  /**
   * FEATURES
   */

  .features-list {
    grid-template-columns: 1fr;
  }

  .features .container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .features .section-title {
    grid-column: 1 / 4;
  }

  .features-banner {
    margin-block: 0;
    display: grid;
    place-items: center;
  }

  /**
   * FOOTER
   */

  .footer-top .container {
    grid-template-columns: repeat(4, 1fr);
  }

  .footer-brand {
    grid-column: 1 / 5;
  }

  .footer-brand .text {
    max-width: 45ch;
  }
}

/**
 * responsive for larger than 1200px screen
 */

@media (min-width: 1200px) {
  /**
   * REUSED STYLE
   */

  .container {
    max-width: 1200px;
  }

  .section-title {
    --fs-3: 4.6rem;
  }

  /**
   * HERO
   */

  .hero {
    min-height: 800px;
  }


}

</style>